import React from 'react'
import { Box, useMediaQuery } from '@mui/material'
import CalendarToggler from 'module/leave/pages/calendar/components/calendarToggler'
import { useTheme } from '@emotion/react'
import TrackerCalendarSearch from './TrackerCalendarSearch'

export default function TrackerCalendarHeader({
    calendarValue,
    setCalendarValue,
    calendarFilter,
    setCalendarFilter,
    handleClick,
    selectedFilters = [],
    setSelectedFilters,
}) {
    const theme = useTheme()
    const md = useMediaQuery(theme.breakpoints.up('md'))
    const sm = useMediaQuery(theme.breakpoints.up('sm'))
    const employeeCount = selectedFilters.filter((item) => item?.type === 'employee').length
    const projectCount = selectedFilters.filter((item) => item?.type === 'project').length
    const filterSummaryParts = [
        employeeCount ? `${employeeCount} employee${employeeCount > 1 ? 's' : ''}` : null,
        projectCount ? `${projectCount} project${projectCount > 1 ? 's' : ''}` : null,
    ].filter(Boolean)

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    minHeight: 56,
                }}
            >
                <CalendarToggler
                    setCalendarValue={setCalendarValue}
                    calendarValue={calendarValue}
                    handleClick={handleClick}
                    md={md}
                    sm={sm}
                />

                {md ? (
                    <TrackerCalendarSearch
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                    />
                ) : null}
            </Box>

            {selectedFilters?.length ? (
                <Box sx={{ mt: 1.25 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mb: 1,
                        }}
                    >
                        <Box sx={{ color: 'text.secondary', fontSize: 14 }}>
                            Filtering by <b>{filterSummaryParts.join(' and ')}</b>:
                        </Box>

                        <Box
                            onClick={() => setSelectedFilters([])}
                            sx={{
                                color: 'primary.main',
                                fontWeight: 600,
                                cursor: 'pointer',
                                userSelect: 'none',
                            }}
                        >
                            Clear all
                        </Box>
                    </Box>

                    {/* Chips row */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            flexWrap: 'wrap',
                            alignItems: 'center',
                        }}
                    >
                        <TrackerCalendarSearch
                            hideInput
                            selectedFilters={selectedFilters}
                            setSelectedFilters={setSelectedFilters}
                        />
                    </Box>
                </Box>
            ) : null}
        </Box>
    )
}
